module.exports = __webpack_public_path__ + "static/media/Women-in-tech.723b2c88.webp";